import { Chip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { CallMissedOutgoing } from "@mui/icons-material";

import { statusItems } from "../CustomersPage/types";

export function getCustomerStatusName(statusId: number) {
    return statusItems.find((item) => item.value === statusId)?.label;
}

function vmStatusColor(status: string) {
    switch (status) {
        case "online":
            return "success";
        case "offline":
            return "default";
        case "provisioning":
            return "warning";
        case "failed":
            return "error";
        case "not_provisioned":
            return "warning";
        default:
            return "default";
    }
}

export const projeto704InfraColumns: GridColDef[] = [
    {
        field: "project_name",
        headerName: "Cliente - App",
        flex: 2,
        renderCell: (params: GridRenderCellParams) => (
            <strong>{params.row.project_name}</strong>
        ),
    },
    {
        field: "customer_status_id",
        headerName: "Status Admin",
        flex: 1,
        renderCell: (params: GridRenderCellParams) => (
            <span>{getCustomerStatusName(params.row.customer_status_id)}</span>
        ),
    },
    {
        field: "vm_status_label",
        headerName: "Status VM (Projeto704)",
        flex: 1.2,
        renderCell: (params: GridRenderCellParams) => (
            <Chip
                size="small"
                label={params.row.vm_status_label || "-"}
                color={vmStatusColor(params.row.vm_status) as any}
                variant="outlined"
            />
        ),
    },
    {
        field: "server_ip",
        headerName: "IP",
        flex: 1,
        renderCell: (params: GridRenderCellParams) => (
            <span>{params.row.server_ip || "-"}</span>
        ),
    },
    {
        field: "divergence_label",
        headerName: "Divergência",
        flex: 2,
        renderCell: (params: GridRenderCellParams) =>
            params.row.has_divergence ? (
                <span style={{ color: "#dc2b2b" }}>
                    {params.row.divergence_label}
                </span>
            ) : (
                <span>-</span>
            ),
    },
    {
        field: "actions",
        headerName: "Ações",
        flex: 0.7,
        align: "right",
        headerAlign: "right",
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
            <CallMissedOutgoing
                style={{ cursor: "pointer" }}
                onClick={() => {
                    window.location.href = `/comercial/customers/customerDetail?id=${params.row.id}`;
                }}
            />
        ),
    },
];
